<template>
    <div class="contactUs">
      <div class="hotCarsTitle">
        <div class="hctMain clearfix">
          <div class="hctMainImg"><img :src="hctIcon" alt=""></div>
          <div class="hctMainTitle">联系我们</div>
        </div>
      </div>
      <!--内容-->
      <h5>{{publicData.CompanyName}}</h5>
      <ul class="cuMain">
        <li>
          <div class="cuMainTitle">请联系：</div>
          <template v-for="item in publicData.ContactInfo">
            <div class="cuMainName"><span>{{item.Name}}</span><span class="cmnNumber">{{item.Phone}}</span><span class="cuMainFootCopy" @click="callPhone(item.Phone)">拨打</span></div>
            <div class="cuMainFoot clearfix">
              <div class="cuMainNumber"><span>微信：</span><span class="cmnNumber">{{item.WxCode}}</span><span class="cuMainFootCopy" :data-clipboard-text="item.WxCode" @click="copyToWx">复制</span></div>
              <!--<div class="cuMainFootCopy" :data-clipboard-text="item.WxCode">【点此一键复制】 去微信</div>-->
            </div>
          </template>
        </li>
        <li>
          <div class="cmFoot"><span>传真：</span><span>{{publicData.FaxCode}}</span></div>
          <div class="cmFoot"><span>邮箱：</span><span>{{publicData.EMail}}</span></div>
          <div class="cmFoot"><span>地址：</span><span>{{publicData.Addr}}</span></div>
        </li>
      </ul>
    </div>
</template>

<script>
  import Clipboard from 'clipboard';
  import {Toast} from 'vant';
    export default {
        name: 'ContactUs',
        props:['publicData'],
        data () {
            return {
              hctIcon:require("../../assets/icon_hotCar.png"),
              contactUsTitle:"广州XX汽车租赁有限公司",
              cmnName:'赵新生',
              cmnNumber:'156456485454',
              cuMainNumber:'lh56565',
              fax:'025645641',
              mailbox:'adakjn@qq.com',
              address:'广州市天河区上赶不上即可兑换空间啊'

            }
        },
      mounted(){
        this.copyBtn = new Clipboard(".cuMainFootCopy");
      },
      methods:{
          copyToWx:function (el) {
            var clipboard = this.copyBtn;
            clipboard.on('success', function(e) {
              console.log(e);
              Toast({type:'html',message:'复制成功，请到微信搜索',onClose() {
                  window.location.href='weixin://';
                }});
            });
            clipboard.on('error', function(e) {
              console.log(e);
              Toast({type:'html',message:'复制失败'});
            });
          },
        callPhone:function (phone) {
          this.axios.post('http://travel.xiangbaoche.cn/api.php/api/Gbook/create_action_count',{site:4,type:1}).then(function (res) {
            console.log(res);
          }).catch(function (err) {
            console.log(err);
          });
          window.location.href = 'tel:'+phone;
        }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

    .hotCarsTitle{width: 100%;height: 60px;background: #f6f6f6}
    .hctMain{width: 300px;background: #2c3e50;background: linear-gradient(-45deg, transparent 45px, #2c3e50 0) bottom right;height: 60px; background-repeat: no-repeat;display: flex}
    .hctMainImg{display: flex;padding-left: 20px;box-sizing: border-box;align-items: center;height: 60px;}
    .hctMainImg img{width: 32px;height: 32px;vertical-align: middle}
    .hctMainTitle{display: flex;font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(255,255,255,1);align-items: center;margin-left: 20px;}

    /*内容*/
    .contactUs h5{font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(44,62,80,1);margin: 40px auto 20px;width: 700px;text-align: left}
    .cuMain{width: 700px;margin: 0 auto;text-align: left}
    .cuMainTitle{font-size: 28px;color: #4d667e;margin-bottom: 20px;}
    .cuMainFoot,.cuMainName{margin-bottom: 20px}
    .cuMainName,.cuMainNumber{font-size: 28px;color: #4d667e;}
    .cmnNumber{color: #1dd2af;margin-left: 20px;}
    .cuMainNumber{float: left}
    .cuMainFootCopy{font-size:28px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(238,69,71,1);margin-left: 20px;}
    .cuMain li{margin-bottom: 20px}
    .cmFoot{font-size:28px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(77,102,126,1);margin-bottom: 5px;}
</style>
<style>
  .van-toast{font-size: 26px;line-height: 40px;}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs/ContactUs.vue